import { Stack, Typography } from '@mui/material';
import { Multiline } from '@procureai/ui-mui';
import { isEmpty, isNil } from 'ramda';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { gridDetailPanelToggleColWidth } from '~/common/constants';

export interface DescriptionDetailRecordCellProps {
  description?: string | null;
}

export const DescriptionDetailRecordCell = ({ description }: DescriptionDetailRecordCellProps) => {
  return (
    <Stack
      spacing={4}
      sx={{
        py: 4,
        pr: 4,
        pl: gridDetailPanelToggleColWidth,
      }}
    >
      <Typography variant="body2" color="textSecondary">
        <>{isNil(description) || isEmpty(description) ? NULLISH_CELL_VALUE : <Multiline>{description}</Multiline>}</>
      </Typography>
    </Stack>
  );
};
